import { projectRoles } from "@/utils/GlobalConstants";

export function getRoleIdFromRoleName(role: "Viewer" | "Team Member" | "Sponsor" | "Project Manager") {
    return projectRoles.find((r) => r.roleName === role)?.roleId ?? 0;
}